import Minus from '../icons/Minus';
import React, { Component } from 'react';
import './tablerow.scss';

class TableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unit: null
    }
  }

  getValues = () => {
    const { data, getUnit } = this.props;
    let newFormattedHeight, newFormattedWeight, formattedDate;

    if (data.Height) {
      newFormattedHeight = data.Height[getUnit()]
    }

    if (data.Weight) {
      newFormattedWeight = data.Weight[getUnit()]
    }

    if (data.Date) {
      formattedDate = data.Date;
    }

    this.setState({
      unit: getUnit(),
      formattedWeight: newFormattedWeight || '',
      formattedHeight: newFormattedHeight || '',
      formattedDate
    })
  }

  handleValueUpdate = (e, state) => {
    this.setState({ [state]: e.target.value });
  }

  UNSAFE_componentWillMount = () => {
    this.getValues();
  }

  componentDidUpdate = () => {
    const { getUnit } = this.props

    if (getUnit() !== this.state.unit) {
      this.getValues();
    }
  }

  render() {
    const { id, index, updateSessionData, deleteRow, isMetric } = this.props;
    const { formattedWeight, formattedHeight, formattedDate } = this.state;

    return (
      <div className="form-row" data-id={id}>

        <div className="form-grid">

          <label>
            <p className="label_title">{this.props.fieldNames.measuredDate}</p>
            <div>
              <input
                id={`Measures-Date:${index}`}
                value={formattedDate}
                onChange={updateSessionData}
                type="date"
                placeholder="dd/mm/yyyy" // Fixes Safari/IE bug, not showing in good browsers
                required
              />
              <span className="suffix"></span>
            </div>
          </label>

          <label>
            <p className="label_title">{this.props.fieldNames.measuredHeight}</p>
            <div>
              <input
                id={`Measures-Height:${index}`}
                value={formattedHeight}
                onBlur={updateSessionData}
                onChange={(e) => this.handleValueUpdate(e, 'formattedHeight')}
                type="number"
                required
              />
              <span className="suffix">({isMetric ? 'cm' : 'in'})</span>
            </div>
          </label>

          <label>
            <p className="label_title">{this.props.fieldNames.measuredWeight}</p>
            <div style={{ width: "100%" }}>
              <input
                id={`Measures-Weight:${index}`}
                value={formattedWeight}
                onBlur={updateSessionData}
                onChange={(e) => this.handleValueUpdate(e, 'formattedWeight')}
                type="number"
                required
              />
              <span className="suffix">({isMetric ? 'kg' : 'lb'})</span>
            </div>


          </label>

        </div>

        {id && <button className="button button-icon" type="button" onClick={() => deleteRow(id)}><Minus /></button>}

      </div>
    )
  }
}

export default TableRow
